import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export interface EndSessionDialogData {
  device: string;
  location: string;
  signedInAt: string;
  isCurrentDevice: boolean;
  employeeName?: string;
}

@Component({
  selector: 'app-dialog-end-session',
  imports: [MatDialogClose, TranslateModule],
  templateUrl: './dialog-end-session.component.html',
  styleUrl: './dialog-end-session.component.scss',
})
export class DialogEndSessionComponent {
  public readonly data: EndSessionDialogData = inject(MAT_DIALOG_DATA);
  public readonly matDialogRef: MatDialogRef<DialogEndSessionComponent, boolean> = inject(MatDialogRef);

  confirm(): void {
    this.matDialogRef.close(true);
  }
}
